import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type MarkEmailIconProps = {
    color?: string
    width?: number
    height?: number
    className?: ClassName
    style?: React.CSSProperties
    ['data-testid']?: string
} & React.ComponentPropsWithRef<'svg'>

export function MarkEmailIcon({
    className,
    style,
    width = 151,
    height = 150,
    color = '#81E18B',
    ['data-testid']: dataTestid = 'mark-email-icon',
}: MarkEmailIconProps): React.ReactElement {
    return (
        <svg width="151" height="150" viewBox="0 0 151 150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_4816_2011"
                // style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width={width}
                height={height}
                className={cn(className)}
                style={style}
                data-testid={dataTestid}
            >
                <rect x="0.5" width="150" height="150" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_4816_2011)">
                <path
                    d="M96.4375 131.562L75.5 110.625L78.625 107.5L96.4375 125.312L132.062 89.6875L135.188 92.8125L96.4375 131.562ZM75.5 68.75L123 37.5H28L75.5 68.75ZM75.5 74.0625L25.5 40.9375V107.5C25.5 108.958 25.9688 110.156 26.9062 111.094C27.8438 112.031 29.0417 112.5 30.5 112.5H59.7188L64.0938 116.875H30.5C27.7917 116.875 25.5521 115.99 23.7812 114.219C22.0104 112.448 21.125 110.208 21.125 107.5V42.5C21.125 39.7917 22.0104 37.5521 23.7812 35.7812C25.5521 34.0104 27.7917 33.125 30.5 33.125H120.5C123.208 33.125 125.448 34.0104 127.219 35.7812C128.99 37.5521 129.875 39.7917 129.875 42.5V74.375L125.5 78.75V40.9375L75.5 74.0625Z"
                    fill={color}
                />
            </g>
        </svg>
    )
}
